import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'




function checkSeatsAndSteeringWheelBadges_q8() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}

function addListeners_q8(frontCheckboxesMap, modalsCheckboxesMap) {
	frontCheckboxesMap['YZ1_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YZ1_Q7Q8',this.checked)
		checkLocks_q8(frontCheckboxesMap)
		getPackageImages_q8('YZ1_Q7Q8', frontCheckboxesMap)
	})

	frontCheckboxesMap['YSJ_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSJ_Q7Q8',this.checked)
		checkLocks_q8(frontCheckboxesMap)
		getPackageImages_q8('YSJ_Q7Q8', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVU_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVU_Q7Q8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YVQ'].checked == false) { 
				frontCheckboxesMap['YVQ'].disabled = true
			}
		} else {
			checkLocks_q8(frontCheckboxesMap)
		}
		getPackageImages_q8('YVU_Q7Q8', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVQ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVQ', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YVU_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YVU_Q7Q8'].disabled = true
			}
		} else {
			checkLocks_q8(frontCheckboxesMap)
		}
		getPackageImages_q8('YVQ', frontCheckboxesMap)
	})	
	
	frontCheckboxesMap['YTA_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTA_Q7Q8', this.checked);
		checkLocks_q8(frontCheckboxesMap)
		getPackageImages_q8('YTA_Q7Q8', frontCheckboxesMap)
	})
	
	/*
	frontCheckboxesMap['YXP'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YXP', this.checked);
		checkLocks_q8(frontCheckboxesMap)
		getPackageImages_q8('YXP', frontCheckboxesMap)
	})
	*/
	
	/*
	frontCheckboxesMap['YVZ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVZ', this.checked);
		checkLocks_q8(frontCheckboxesMap)
		getPackageImages_q8('YVZ', frontCheckboxesMap)
		

		//CheckModalVisibility
		const modal = document.querySelectorAll('.modal')[0]
		if (this.checked) {
			modal.classList.remove("hidden")
		} else {
			modal.classList.add("hidden")
		}
		
	})
	*/
	
	frontCheckboxesMap['YTO_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTO_Q7Q8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTQ_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YTQ_Q7Q8'].disabled = true
			}
		} else {
			checkLocks_q8(frontCheckboxesMap)
		}
		getPackageImages_q8('YTO_Q7Q8', frontCheckboxesMap)
	})

	frontCheckboxesMap['YTQ_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTQ_Q7Q8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTO_Q7Q8'].checked == false) { 
				frontCheckboxesMap['YTO_Q7Q8'].disabled = true
			}
		} else {
			checkLocks_q8(frontCheckboxesMap)
		}
		getPackageImages_q8('YTQ_Q7Q8', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YSR_Q7Q8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSR_Q7Q8', this.checked);
		checkLocks_q8(frontCheckboxesMap)
		getPackageImages_q8('YSR_Q7Q8', frontCheckboxesMap)
	})
}

/**Controls frontcheckboxes disable */
function checkLocks_q8(frontCheckboxesMap) {
	//DEFINE UNLOCK CONDITIONS
	//const unlockConditionForYSN = !frontCheckboxesMap['YSJ_Q7Q8'].checked && !frontCheckboxesMap['YVK'].checked
	//const unlockConditionForYSJ_Q7Q8 = !frontCheckboxesMap['YVK'].checked
	//const unlockConditionForYVK = !frontCheckboxesMap['YSJ_Q7Q8'].checked

	const unlockConditionForYVU_Q7Q8 = !frontCheckboxesMap['YVQ'].checked
	const unlockConditionForYVQ = !frontCheckboxesMap['YVU_Q7Q8'].checked
	//const unlockConditionForYSR_Q7Q8 = !frontCheckboxesMap['YSQ_Q7Q8'].checked
	//const unlockConditionForYSQ_Q7Q8 = !frontCheckboxesMap['YSR_Q7Q8'].checked
	const unlockConditionForYTQ_Q7Q8 = !frontCheckboxesMap['YTO_Q7Q8'].checked
	const unlockConditionForYTO_Q7Q8 = !frontCheckboxesMap['YTQ_Q7Q8'].checked
	//const unlockConditionForYVZ = true

	
	//UPDATE VARS 
	//frontCheckboxesMap['YSN'].disabled = !unlockConditionForYSN
	//frontCheckboxesMap['YSJ_Q7Q8'].disabled = !unlockConditionForYSJ_Q7Q8
	
	//frontCheckboxesMap['YVK'].disabled = !unlockConditionForYVK
	frontCheckboxesMap['YVU_Q7Q8'].disabled = !unlockConditionForYVU_Q7Q8
	frontCheckboxesMap['YVQ'].disabled = !unlockConditionForYVQ
	//frontCheckboxesMap['YSR_Q7Q8'].disabled = !unlockConditionForYSR_Q7Q8
	//frontCheckboxesMap['YSQ_Q7Q8'].disabled = !unlockConditionForYSQ_Q7Q8

	frontCheckboxesMap['YTQ_Q7Q8'].disabled = !unlockConditionForYTQ_Q7Q8
	frontCheckboxesMap['YTO_Q7Q8'].disabled = !unlockConditionForYTO_Q7Q8
	//frontCheckboxesMap['YVZ'].disabled = !unlockConditionForYVZ
}


/**Gets images for all packages depending on selected packages */

function getImages_q8(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		//When screen loading
		/*
		const YRB_WAS_MODAL_SELECTED = frontCheckboxesMap['YVJ'].checked && frontCheckboxesMap['YSI'].checked
		const YVN_WAS_MODAL_SELECTED = frontCheckboxesMap['YVJ'].checked && frontCheckboxesMap['YSJ_A6'].checked
		*/
		/*
		if (YRB_WAS_MODAL_SELECTED || YVN_WAS_MODAL_SELECTED) {
			getPackageImages_a6limousine(YRB_WAS_MODAL_SELECTED ? 'YSI-YVJ' : 'YSJ_A6-YVJ', frontCheckboxesMap)
		}else{
			getPackageImages_a6limousine(checkboxKey, frontCheckboxesMap)
		}*/
		getPackageImages_q8(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_q8(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}


export { addListeners_q8, saveStateWithAjax, checkLocks_q8, getImages_q8, getPackageImages_q8, checkSeatsAndSteeringWheelBadges_q8}

